/**
 * Skeleton Component
 */

import React, { Fragment } from 'react';
import { SkeletonProps } from './skeleton.types';
import { StyledBaseSkeleton } from './skeleton.style';
import { useTheme } from 'styled-components';

const getLoadingClassName = (className: string = '', isLoading: boolean) => {
  const temp: string[] = [className];

  if (isLoading) {
    temp.push('is-loading');
  }

  return temp.join(' ');
};

const Skeleton = ({
  height = '100%',
  width = '100%',
  borderRadius = '5px',
  isCircle = false,
  animation = true,
  isLoading,
  children,
  className,
  margin = 5,
  count = 1,
}: SkeletonProps) => {
  const theme = useTheme();
  const skeletonArr = [];
  const completeProps: SkeletonProps = {
    height,
    width,
    borderRadius,
    animation,
    isCircle,
    theme,
    children,
    className,
    margin,
    count,
    isLoading,
  };

  for (let i = 0; i < count; i++) {
    const skeletonItemId: string = `skeleton-item-${i}`;
    if (typeof isLoading !== 'undefined') {
      const completePropsNew: SkeletonProps = {
        ...completeProps,
        className: getLoadingClassName(className, isLoading),
      };
      skeletonArr.push(
        <StyledBaseSkeleton {...completePropsNew} key={skeletonItemId}>
          <span>{children}</span>
        </StyledBaseSkeleton>,
      );
    } else {
      skeletonArr.push(<StyledBaseSkeleton {...completeProps} key={skeletonItemId} />);
    }
  }

  return <Fragment>{skeletonArr}</Fragment>;
};

export default Skeleton;
